import { render } from "./Profile-Own.vue?vue&type=template&id=2343c4c4"
import script from "./Profile-Own.vue?vue&type=script&lang=js"
export * from "./Profile-Own.vue?vue&type=script&lang=js"

import "./Profile-Own.vue?vue&type=style&index=0&id=2343c4c4&lang=less"

import exportComponent from "C:\\Users\\bartelmus\\Desktop\\git\\spiel26-frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__